/**
 *
 * ClipText
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';

export default class ClipText extends React.Component {
  constructor(props) {
    super(props);
    const shouldClip = props.text && props.text.length > this.props.clipLength;
    this.state = {
      shouldClip,
      isFull: false,
    };
    this.toggleView = this.toggleView.bind(this);
  }
  toggleView() {
    const { isFull } = this.state;
    this.setState({ isFull: !isFull });
  }
  clippedText() {
    return this.props.text.slice(0, this.props.clipLength);
  }

  render() {
    const { shouldClip, isFull } = this.state;

    if (shouldClip && !isFull) {
      return (
        <div>
          {this.clippedText()}
          <span className="more more--blue" onClick={this.toggleView}>
            show more
          </span>
        </div>
      );
    }
    return (
      <div>
        {this.props.text}
        {shouldClip &&
          isFull && (
            <span className="more more--blue" onClick={this.toggleView}>
              show less
            </span>
          )}
      </div>
    );
  }
}

ClipText.propTypes = {
  text: PropTypes.string,
  clipLength: PropTypes.number,
};
